<template>
    <div>
        <b-container class="mt-5">
            <b-row>
                <b-col>
                    <h1>
                        This invite is invalid.
                    </h1>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>